/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/Lock';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const LockIcon = withMuiAdapter(Base, 'Lock');
